import DashboardEngine from "./dashboardEngine"; // 👈 import to use inside macros
const dashboardData = {
  context: { globalCounter: 1 },

  uiJson: {
    layout: { top: [], center: [], bottom: [] },
    macros: {}
  }
};

// first module template + macros defined here
dashboardData.uiJson.layout = {
  top: [
    { type: "button", label: "➕ Add Module", onClick: "duplicateCenter" },
    { type: "button", label: "🗑 Clear Modules", onClick: "resetCenter" }
  ],
  center: [
    {
      type: "module",
      id: "mainModule",
      layout: {
        left: [
          {
            type: "expandableMenu",
            title: "Datasets",
            items: [
              { label: "Q1", dataset: "Q1" },
              { label: "Q2", dataset: "Q2" }
            ]
          }
        ],
        right: [
          { type: "table", source: "${selectedDataset}" },
          { type: "kpi", value: "${totalRevenue}", label: "Total Revenue" },
          { type: "button", label: "Recalculate", onClick: "calculateRevenue" }
        ]
      },
      moduleContext: {
        datasets: {
          Q1: [
            { Product: "A", Revenue: 100 },
            { Product: "B", Revenue: 200 }
          ],
          Q2: [
            { Product: "A", Revenue: 150 },
            { Product: "B", Revenue: 250 }
          ]
        },
        selectedDataset: "Q1",
        totalRevenue: 0
      }
    }
  ],
  bottom: [
    { type: "text", content: "© 2025 TractumQuery Modular Engine" }
  ]
};

// macros
dashboardData.uiJson.macros = {
  calculateRevenue: {
    logic: (context) => {
      const ds = context.datasets[context.selectedDataset] || [];
      context.totalRevenue = ds.reduce((sum, r) => sum + (r.Revenue || 0), 0);
    }
  },
  duplicateCenter: {
    logic: (context, uiJson, containerId) => {
      const id = context.globalCounter++;
      const template = uiJson.layout.center[0];
      const newModule = JSON.parse(JSON.stringify(template));

      newModule.id = `module-${id}`;
      newModule.moduleContext = {
        datasets: {
          Q1: [
            { Product: "A", Revenue: 100 + id * 50 },
            { Product: "B", Revenue: 200 + id * 50 }
          ],
          Q2: [
            { Product: "A", Revenue: 150 + id * 50 },
            { Product: "B", Revenue: 250 + id * 50 }
          ]
        },
        selectedDataset: "Q1",
        totalRevenue: 0
      };

      uiJson.layout.center.push(newModule);
      DashboardEngine.render(containerId, uiJson, context);
    }
  },
  resetCenter: {
    logic: (context, uiJson, containerId) => {
      const first = JSON.parse(JSON.stringify(uiJson.layout.center[0]));
      uiJson.layout.center = [first];
      DashboardEngine.render(containerId, uiJson, context);
    }
  }
};
export { dashboardData };